<template>
    <div class="content-wrap content-wrap--bigger" style="position:fixed;">
      <header class="header">
        <span class="header-backlink icon-zurueck" @click="close"></span>
        <p class="header-title"> <span v-text="title"></span></p>
      </header>
      <div class="">
        <slot />
      </div>
    </div>
</template>

<script>
    export default {
        name: "SubPage",
        data() {
            return {};
        },
        props: {
          title : {
            default: '',
            required: true
          }
        },
        methods: {
            close: function() {
                Events.$emit('subpage.close' );
            }
        }
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layouts/SubPage.vue